/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 4/9/14
 * Time: 8:22 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/attributesConfigView.tmpl");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var AttributesConfigItemView = require("manager-views/data-sources/attributes/AttributesConfigItemView");

    var AttributesConfigView = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        AttributesConfigView = Marionette.CompositeView.extend({
            template: template,
            className: "edit-list-container browser-scroll scroll-fixed light",
            itemView: AttributesConfigItemView,
            initialize: function(options){
                LEManager.logger.debug("AttributesConfigView:initialize");
                this.vent = LEManager.media.channel("dataSources").vent;
                this.selectedAttributeModel = options.selectedAttributeModel;
                this.selectedRowModel = options.selectedRowModel;
                this.itemViewOptions = {
                    skillsCollection: options.skillsCollection,
                    selectedAttributeModel: options.selectedAttributeModel,
                    selectedRowModel: options.selectedRowModel
                };
            },
            onRender: function(){
                LEManager.logger.debug("AttributesConfigView:onRender");
                if (!_.isNull(this.selectedAttributeModel)){
                    _.defer(_.bind(this._scrollToSdeSection, this));
                }
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.root.TRIGGERING.CONFIG_VIEW_RENDERED, this);
            },
            _scrollToSdeSection: function(){
                LEManager.logger.debug("AttributesConfigView:_scrollToSdeSection");
                var logicalName = this.selectedAttributeModel.getLogicalName();
                var elementContainer = this.$el.find(".data-sources-" + logicalName);
                if (elementContainer.length > 0){
                    this.$el.scrollTop(0);
                    var diff = elementContainer.offset().top - this.$el.offset().top;
                    LEManager.logger.debug("AttributesConfigView:_scrollToSdeSection - diff: " + diff);
                    this.$el.scrollTop(diff);
                }
            },
            onClose: function(){
                LEManager.logger.debug("AttributesConfigView:onClose");
            }
        });
    });
    return AttributesConfigView;
});

